import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import CategoryDetailsMain from '../Components/Category/CategoryDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'

function CategoryDetails() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title="Category Details"
            />
            <CategoryDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default CategoryDetails
